import { render, staticRenderFns } from "./TabGraficoComposicaoCustoTotal.vue?vue&type=template&id=2f211527&scoped=true&"
import script from "./TabGraficoComposicaoCustoTotal.vue?vue&type=script&lang=js&"
export * from "./TabGraficoComposicaoCustoTotal.vue?vue&type=script&lang=js&"
import style0 from "./TabGraficoComposicaoCustoTotal.vue?vue&type=style&index=0&id=2f211527&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f211527",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VFlex,VTab,VTabItem,VTabs})
